import { createLogger } from '@yoti-web-share/logger'

export const logger = createLogger('iframe-client', { prefix: 'Iframe-Client' })
